import { createNamespacedHelpers } from "vuex";
const walletVuex = createNamespacedHelpers("wallet");
import loadConfig from "@Web3WalletConfig/config";
export default {
  name: "gift",
  computed: {
    ...walletVuex.mapState(["isMobile", "theme", 'setting'])
  },
  data() {
    return {
      category_id: '',
      loadConfig,
      isLock: false,
      list: {},
      assetsChains: [],
      popAssetsTokensShow: false,
      modifyData: {
        "icon": ""
      },
      isLoading: false,
      chain_id: ""
    };
  },
  methods: {
    async getData() {
      this.isLoading = true;
      let rs = await this.$http.post("/assets/tokens", {
        chain_id: this.chain_id
      });
      this.isLoading = false;
      if (rs.code == 0) {
        this.list = rs.data;
      }
    },
    async onCreate() {
      this.modifyData = {
        "icon": "",
        'status': "1",
        "sort": "0",
        "pre_type": 0
      };
      this.popAssetsTokensShow = true;
    },
    async onModify(item) {
      this.modifyData = item;
      this.popAssetsTokensShow = true;
    },
    cutStr(str) {
      if (str) return str.replace("T", " ").replace(".000Z", "");
    },
    onRefresh() {
      this.getData();
    },
    onChange(e) {
      this.chain_id = e;
    }
  },
  async mounted() {
    this.chain_id = this.$route.query.id || '';
    let rs = await this.$http.post("/assets/chains", {});
    if (rs.code == 0) {
      this.assetsChains = rs.data;
    }
    this.getData();
  }
};